var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eos-icons:admin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 1.33398L4 6.66732V14.6673C4 22.0673 9.12 28.9873 16 30.6673C22.88 28.9873 28 22.0673 28 14.6673V6.66732L16 1.33398ZM16 6.53398C16.7911 6.53398 17.5645 6.76858 18.2223 7.20811C18.8801 7.64763 19.3928 8.27235 19.6955 9.00325C19.9983 9.73416 20.0775 10.5384 19.9231 11.3143C19.7688 12.0903 19.3878 12.803 18.8284 13.3624C18.269 13.9218 17.5563 14.3028 16.7804 14.4571C16.0044 14.6115 15.2002 14.5323 14.4693 14.2295C13.7384 13.9268 13.1136 13.4141 12.6741 12.7563C12.2346 12.0985 12 11.3251 12 10.534C12 9.47312 12.4214 8.4557 13.1716 7.70556C13.9217 6.95541 14.9391 6.53398 16 6.53398ZM16 17.0673C18.6667 17.0673 24 18.5207 24 21.174C23.1243 22.4941 21.9355 23.5771 20.5396 24.3262C19.1438 25.0753 17.5842 25.4674 16 25.4674C14.4158 25.4674 12.8562 25.0753 11.4604 24.3262C10.0645 23.5771 8.8757 22.4941 8 21.174C8 18.5207 13.3333 17.0673 16 17.0673Z",
    fill: "url(#paint0_linear_1008_2204)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1008_2204",
    x1: 16,
    y1: 1.33398,
    x2: 16,
    y2: 30.6673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4056DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3746A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIcon);
export default __webpack_public_path__ + "static/media/admin_icon.8ae29a2226e1fa9dcc50bd88fa019acc.svg";
export { ForwardRef as ReactComponent };